import axios from 'axios'

export const SendToServer = (username, password, sgn) => {
    const URL = '/aid/generate-token'
    // const nodeURL = '/token/generate-token'
     return axios({
        method: 'post',
        url: URL,
        data: {
          api:"authApi",
          username: username,
          password: password,
          sign: sgn
        }
      })
     
}

export const searchRecipientRegistr = (data) =>axios.post(`/aid/recipientSearch`, data);

//--------------------------catalogs------------------------------------------------

// http://10.3.0.44:8088/request 

export const getRegion  = () =>axios.get(`/ref/regions`);
export const getAuth  = () =>axios.get(`/geturl`);
export const getLocality = (region) =>axios.get(`/ref/unitsbyregion/${region}`);
export const postRequest = (data) =>axios.post(`/request`, data);


export const getMenu  = () =>axios.get(`/aid/getmenu`);
// export const getRegion  = () =>axios.get(`/aid/getRegion`);
// export const getLocality = (region) =>axios.get(`/aid/getLocality/${region}`);
export const applicationState = () =>axios.get(`/aid/applicationState`);
export const applicationType = () =>axios.get(`/aid/applicationType`);
export const acquirerType = () =>axios.get(`/aid/acquirerType`);
export const aidCondition = () =>axios.get(`/aid/aidCondition`);
export const aidForm = () =>axios.get(`/aid/aidForm`);
export const aidType = () =>axios.get(`/aid/aidType`);
export const country = () =>axios.get(`/aid/country`);
export const organization = () =>axios.get(`/aid/organization`);
export const reciver = () =>axios.get(`/aid/reciver`);
export const userState = () =>axios.get(`/aid/userstate`);
export const meetingState = () =>axios.get(`/aid/meetingstate`);
export const decisonType = () =>axios.get(`/aid/decisontype`);

//---------------------------------------------------------------------------------

export const getRecipient = (id) =>axios.get(`/aid/getRecipient/${id}`);
//export const getRecipientFull = (id) =>axios.get(`/aid/getRecipientFull/${id}`);
export const getRecipientFull = (id) =>axios.get(`/aid/getRecipientFullold/${id}`);
export const getRecipientFullNew = (id) =>axios.get(`/aid/getRecipientFull2/${id}`);
//export const getRecipientFullApr = (id, user_id) =>axios.get(`/aid/getRecipientFullApr/${id}/${user_id}`); //view for register
export const getRecipientHistory = (id) =>axios.get(`/aid/ApplicationsByRecipient/${id}`);
export const getRecipients = (id) =>axios.get(`/aid/getRecipients/${id}`);
export const deleteRecipient = (id) =>axios.get(`/aid/delRecipient/${id}`);
export const saveRecipient = (data) =>axios.post(`/aid/saveRecipient`, data);

export const applyApplication = (id) => axios.get(`/aid/apply/${id}`)

export const approveAuthority = (data) =>axios.post(`/aid/approveAuthority`, data);
export const deniedAuthority = (data) =>axios.post(`/aid/denieAuthority`, data);


export const controlForDeleteRecipientFromRegister = (user_id,recipient_id) =>axios.get(`/aid/statusrecip/${user_id}/${recipient_id}`);

export const deleteRecipientFromRegisterApi = (data) =>axios.post(`/aid/setNewApplication`, data, {
  headers: {
    'Content-Type': 'application/json'
  }
});

//-------------documents recipient---------------
export const saveRecipientDocumentsApi = (info, data) =>axios.post(`/aid/docSave/${info.id}/${info.p_application}/${info.p_doctype}`, data, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});
export const deleteRecipientDocumentsApi = (id) =>axios.get(`/aid/delDocument/${id}`);
export const getRecipientDocumentsApi = (application_id) =>axios.get(`/aid/docByApplication/${application_id}`)


export const getAprovedRecipients = (id) => axios.get(`/aid/ApprovedRecipient/${id}`)
export const applyAppRecipient = (data) => axios.post(`/aid/newApply`, data)
export const saveNewApply = (data) => axios.post(`/aid/savenewApply`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
})

// export const setNewApplication = (data) =>axios.post(`/aid/setNewApplication`, data, {
//   headers: {
//       'Content-Type': 'application/json'
//   }
// });

export const setNewApplication = (data) =>axios.post(`/aid/appChangesforRecipient`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

export const setNewApplicationCargo = (data) =>axios.post(`/aid/applicationForChangeOrder`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

//-------------cargo---------------
export const getCargo = (id) =>axios.get(`/aid/getCargoByRecipient/${id}`);
export const deleteCargo = (id) =>axios.get(`/aid/delCargo/${id}`);
export const deleteAqcuirer = (id) =>axios.get(`/aid/delAcquirer/${id}`);
export const deleteAid = (id) =>axios.get(`/aid/delAid/${id}`);
export const getCargoByIdFullFetchNewOrder = (id) =>axios.get(`/aid/getCargoFull/${id}`);
export const getCargoByIdFullFetch = (id) =>axios.get(`/aid/getCargoFullRead/${id}`);
export const getCargoPublic = (id) =>axios.get(`/aid/getCargoPublic/${id}`);
export const getCargoByIdFetch = (id) =>axios.get(`/aid/getCargo/${id}`);
export const getMyCargo = (id) =>axios.get(`/aid/cargobyApplicant/${id}`);
export const getAcquirerById = (id) =>axios.get(`/aid/Acquirer/${id}`);

export const getAidCargo = (id) =>axios.get(`/aid/getAidList/${id}`);

export const saveCargoAid = (data) =>axios.post(`/aid/saveAid`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

export const saveCargoAquire = (data) =>axios.post(`/aid/saveAquire`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

export const saveCargo = (data) =>axios.post(`/aid/saveCargoDon`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

export const saveDistribution = (data) =>axios.post(`/aid/saveDistr`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

export const getCargoByFilters = (data) =>axios.post(`/aid/getCargoByFilter`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

export const changeRecipientCargo = (data) =>axios.post(`/aid/changeRecipientInCargo`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});
export const cargoApply = (data) =>axios.post(`/aid/setappstate`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});

export const cargoSetApply = (data) =>axios.post(`/aid/cargosetapply`, data, {
  headers: {
      'Content-Type': 'application/json'
  }
});


//export const getCargoReport = (id) =>axios.get(`/aid/cargoreport/${id}`);
export const getCargoReport = (id) =>axios.get(`/aid/distributionAll/${id}`);

export const setReport = (id) =>axios.get(`/aid/setreport/${id}`);
export const getViewReport = (id) =>axios.get(`/aid/distributionSum/${id}`);

export const changeCargoRecipient = (user_id,cargo_id) =>axios.get(`/aid/statuscargo/${user_id}/${cargo_id}`);

//-------------documents cargo---------------
export const saveCargoDocumentsApi = (info, data) =>axios.post(`/aid/docSave/${info.id}/${info.p_application}/${info.p_doctype}`, data, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});
export const getСargoDocumentsApi = (application_id) =>axios.get(`/aid/docByApplication/${application_id}`)

export const deleteCargoDocumentsApi = (id) =>axios.get(`/aid/delDocument/${id}`);
export const recDoc = (id) =>axios.get(`/aid/recDoc/${id}`);
export const cargDoc = (id) =>axios.get(`/aid/cargDoc/${id}`);

//---- main docs in html --------

export const getOrderDoc = (id) =>axios.get(`/aid/getOrder/${id}`);
export const getProtocolDoc = (id) =>axios.get(`/aid/getProtocol/${id}`);

export const getOrderCargoDoc = (id) =>axios.get(`/aid/getOrderCargo/${id}`);
export const getProtocolCargoDoc = (id) =>axios.get(`/aid/getProtocolCargo/${id}`);

//export const getOrderCargoDoc = (id) =>axios.get(`/aid/getOrderCargo/${id}`);
//export const getProtocolCargoDoc = (id) =>axios.get(`/aid/getProtocol/${id}`);

//---- commission --------

export const getCommissionsByFilters = (data) =>axios.post(`/aid/getmeeting`, data, {
  headers: {
    'Content-Type': 'application/json'
}
});



export const saveDecision = (data) =>axios.post(`/aid/saveDecision`, data, {
  headers: {
    'Content-Type': 'application/json'
}
});

export const getNewMeetingInfo = (userId) =>axios.get(`/aid/getnewmeeting/${userId}`);
export const getmeetingByRecipient = (id) =>axios.get(`/aid/getmeetingByRecipient/${id}`);
export const getmeetingByCargo = (id) =>axios.get(`/aid/getmeetingByCargo/${id}`);
export const deleteMeeting = (id) =>axios.get(`/aid/delmeeting/${id}`);

export const getApplicationForCommission = (meetingId)=>axios.get(`/aid/getaplication/${meetingId}`);

export const getMyMeetingInfo = (userId) =>axios.get(`/aid/getmeeting/${userId}`);
export const meetingResult = (id) =>axios.get(`/aid/meetingAppListApr/${id}`);
export const getRecipientOldNew = (id) =>axios.get(`/aid/getRecipientOldNew/${id}`);
//export const getCargoOldNew = (id) =>axios.get(`/aid/getCargoOldNew/${id}`);
export const getCargoOldNew = (id) =>axios.get(`/aid/getCargoOldNew2/${id}`);
export const getMeetingList = (id, userId) =>axios.get(`/aid/meetingAppList/${id}/${userId}`);
export const finishMeeting = (id, userId) =>axios.get(`/aid/finishmeeting/${id}/${userId}`);

export const saveCurrentApplicationState = (id_meeting,id_app,state_check) => axios.get(`/aid/agenda/${id_meeting}/${id_app}/${state_check}`); 

export const saveAllApplicationState = (id_meeting,state_check) => axios.get(`/aid/agendaAll/${id_meeting}/${state_check}`);

export const meetingStartApi = (id_meeting,id_user) => axios.get(`/aid/startmeeting/${id_meeting}/${id_user}`);
